import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withTranslation, Trans } from 'react-i18next';

import Button from 'app/common/ui/Button';
import IconSettings from 'app/components/_Icons/IconSettings';
import {
  IconAppDining,
  IconAppPassages,
  IconAppBook,
  IconAppGradeBook,
  IconBtnPlug,
  IconBtnMenu,
} from 'app/components/_Icons';
import TariffModal from 'app/components/Subs/TariffModal';
import TariffsList from 'app/components/Subs/TariffsList';

import styles from './ApplicationNA.scss';


// const propTypes = {
//   type: React.PropTypes.string.isRequired,
//   name: React.PropTypes.string.isRequired,
//   description: React.PropTypes.string.isRequired,
//   studentId: React.PropTypes.number.isRequired,
//   settings: React.PropTypes.oneOfType([
//     React.PropTypes.string,
//     React.PropTypes.bool,
//   ]),
//   dealer: React.PropTypes.shape({
//     company: React.PropTypes.string.isRequired,
//     phone: React.PropTypes.string,
//   }),
// };

class ApplicationNA extends React.Component {
  state = {
    showConnectInfo: false,
    showAllTariffs: false,
  };

  handleShowConnectInfo = () => {
    this.setState({ showConnectInfo: true });
  }

  handleShowAllTariffs = (e) => {
    if (e) e.preventDefault();
    this.setState({ showAllTariffs: true });
  }

  handleClose = (e) => {
    e.preventDefault();
    this.setState({ showAllTariffs: false });
  }

  renderIcon = () => {
    const { name } = this.props;
    switch (name) {
      case 'Столовая': {
        return <IconAppDining className={styles.icon} />;
      }
      case 'Проходная': {
        return <IconAppPassages className={styles.icon} />;
      }
      case 'Журнал': {
        return <IconAppBook className={styles.icon} />;
      }
      case 'Дневник': {
        return <IconAppGradeBook className={styles.icon} />;
      }
      default: {
        return <IconAppGradeBook className={styles.icon} />;
      }
    }
  };

  render() {
    const {
      type,
      name,
      description,
      studentId,
      settings,
      service,
      dealer: {
        company,
        phone,
      },
      t,
    } = this.props;

    const { showConnectInfo, showAllTariffs } = this.state;

    return (
      <div className={styles.root}>

        <div className={styles.header}>
          {this.renderIcon()}
          <div>
            <div className={styles.type}>{type}</div>
            <h2 className={styles.name}>{name}</h2>
          </div>
          {settings
            && <Link to={settings} className={styles.settings}>
              <IconSettings />
            </Link>}
        </div>

        <div className={styles.descr}>
          {showConnectInfo
            ? <div>
              <div>
                <Trans i18nKey="subs:to_connect_comment">
                  {'Для подключения обратитесь к поставщику услуги'}
                </Trans>
                {':'}
              </div>
              <div className={styles.company}>{company}</div>
              {phone
                && <div>
                  <Trans i18nKey="subs:to_connect_phone_title">Телефон</Trans>
                  {': '}
                  {phone}
                </div>}
            </div>
            : description}
        </div>
        <div className={styles.footer}>
          {name === 'Столовая'
            && <Button warning outline href={`/apps/${studentId}/cafeteria/menu/`}>
              <Trans i18nKey="subs:cafe_menu_bt">
                {'Меню столовой'}
              </Trans>
              <IconBtnMenu className={styles.iconBtnMenu} />
            </Button>}
          <Button warning className={styles.button} onClick={this.handleShowAllTariffs}>
            <Trans i18nKey="subs:connect_bt">
              {'Подключить'}
            </Trans>
            <IconBtnPlug className={styles.iconBtnPlug} />
          </Button>
        </div>
        {showAllTariffs
          && <TariffModal
            title={t('tariff_list_title')}
            description={t('tariff_list_description', { appName: name })}
            close={this.handleClose}
          >
            <TariffsList
              service={service}
              studentId={studentId}
              close={this.handleClose}
            />
          </TariffModal>}
      </div>
    );
  }
}

export default compose(
  withTranslation('subs'),

  connect(
    state => ({
      dealer: state.dealer,
    })
  )
)(ApplicationNA);
